import { LightningElement } from "lwc";

export default class extends LightningElement {}
